<template>
  <div class="row">
    <div class="col-md-12">
      <div class="ibox">
        <div class="ibox-content p-t-m">
          <div class="row m-t-m">
            <div class="col-md-4">
              <h1 class="form-section-title">Product Info</h1>
            </div>
            <div class="col-md-8">
              <div class="form-group">
                <label for="product_name">Name</label>
                <input id="product_name" v-model="name" type="text" class="form-control">
              </div>
              <div class="form-group">
                <label class="m-r-sm">
                  Category
                </label>
                <select v-model="category" class="form-control" :disabled="existingProduct && existingProduct.category === 'bundle'">
                  <option selected disabled>Choose category...</option>
                  <option value="clothing">Clothing</option>
                  <option value="donation">Donation</option>
                  <option value="private_lesson">Private Lesson</option>
                  <option value="service">Service</option>
                  <option value="ticket">Ticket</option>
                  <option value="bundle" :disabled="existingProduct && existingProduct.category !== 'bundle'">Bundle (families pick a size for several items)</option>
                  <option value="other">Other</option>
                </select>
              </div>
              <div class="form-group">
                <label class="m-r-sm m-b-none">
                  Description
                </label>
                <input id="description-editor" type="hidden" name="content">
                <trix-editor id="trix-description" input="description-editor" class="trix-content"></trix-editor>
              </div>
              <div class="form-group" v-show="isClothing">
                <label class="m-r-sm m-b-none">
                  Fabric & Care (optional)
                </label>
                <input id="fabric-editor" type="hidden" name="content">
                <trix-editor id="trix-fabric" input="fabric-editor" class="trix-content"></trix-editor>
              </div>
              <div v-show="this.category && !isPrivateLesson && !isBundle">
                <div class="form-group m-b-xxs">
                  <label class="checkbox-inline">
                    <input type="checkbox" v-model="collectAttendeeInfo"> Collect attendee names at checkout
                  </label>
                  <p class="text-gray-500 text-12 m-t-xxs m-b-none">
                    Great for tickets (banquets, clinics). Buyers will be asked for the name of each person attending.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="row m-t-xl" v-if="!isBundle">
            <div class="col-md-4">
              <h1 class="form-section-title">
                <span v-if="isPrivateLesson">
                  Private Lesson Pricing
                </span>
                <span v-else>
                  Sku Pricing
                </span>
              </h1>
            </div>
            <div class="col-md-8">
              <div v-if="!this.category">
                <p>Please select a category to add skus (price points).</p>
              </div>
              <div v-else>
                <div v-if="isPrivateLesson" class="m-t-sm relative border border-solid border-green-600 rounded-xxs">
                  <div class="flex align-items-center justify-center gap-sm bg-green-600 text-green-50 uppercase tracking-wide p-x-m p-y-xs -m-sm rounded-t-xxs">
                    <span class="text-heavy">WIQ RECOMMENDATION</span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 text-green-50">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M12 18v-5.25m0 0a6.01 6.01 0 001.5-.189m-1.5.189a6.01 6.01 0 01-1.5-.189m3.75 7.478a12.06 12.06 0 01-4.5 0m3.75 2.383a14.406 14.406 0 01-3 0M14.25 18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 10-7.517 0c.85.493 1.509 1.333 1.509 2.316V18" />
                    </svg>
                  </div>
                  <div class="p-x-lg p-y-md grid grid-cols-2 gap-y-sm gap-x-lg sm-grid-cols-1 md-grid-cols-1 m-t-sm">
                    <div>
                      <h1 class="m-t-none font-heavy">
                        Private Lesson Pricing
                      </h1>
                      <p>
                        We recommend having 1 product for each type of coach offering privates (e.g. Head Coach, Assistant Coach, etc.), with multiple price points for each group size you offer.
                      </p>
                      <p>
                        Multiple coaches can re-use the same product / price points, which makes it easier to manage and scale.
                      </p>
                      <p>
                        <strong>Note:</strong> Private lesson pricing is denoted as per hour, per wrestler. If your private lesson is actually shorter or longer than that, the system will calculate the price based on 30 minute increments.
                      </p>
                    </div>
                    <div class="flex flex-col gap-xl justify-center w-full p-x-md">
                      <div class="flex flex-col gap-sm justify-center align-items-center hidden">
                        <a href="javascript:void(0)" onclick="Beacon('article', '6328c8ff62b5f93d180188ad', { type: 'modal' })" class="btn btn-default btn-block w-full justify-center flex align-items-center gap-x-xs"><i class='fa-solid fa-play'></i>
                          Watch Best Practices Video</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="bg-gray-50 border-bottom p-y-m grid font-semi text-gray-500 uppercase tracking-wide m-b-sm m-t-m"
                     :class="getGridColsClass()"
                >
                  <div class="p-l-xs">
                    Name
                  </div>
                  <div v-if="isPrivateLesson">
                    Max # of Wrestlers
                  </div>
                  <div>
                    Price<span v-if="isPrivateLesson" class="text-12"><br/>per hour, per wrestler</span>
                  </div>
                  <div v-if="isPrivateLesson">
                    Facility Fee<span class="text-12"><br/>$/hour or % of price</span>
                  </div>
                  <div v-if="isClothing">
                    Fit<span class="text-12"><br/>optional</span>
                  </div>
                  <div v-if="isClothing">
                    Color<span class="text-12"><br/>optional</span>
                  </div>
                  <div v-if="isClothing">
                    Size
                  </div>
                  <div v-if="!isPrivateLesson">
                    Sku ID
                  </div>
                  <div v-if="showAttendeeCountColumn">
                    Attendees<span class="text-12"><br/>per sku</span>
                  </div>
                  <div class="">
                    Status
                  </div>
                </div>
                <!-- billingPlans is kept sorted active-first, so the Inactive header goes before the first inactive sku -->
                <template v-for="(plan, index) in billingPlans">
                <div v-if="index === firstInactiveIndex"
                     key="inactive-divider"
                     data-cy="sku-inactive-header"
                     class="p-y-xs p-l-xs m-t-m m-b-xs"
                     style="color: #6b7280; border-bottom: 2px solid #d1d5db;">
                  <!-- Neutral gray on purpose: the gray-* utilities (and text-muted) are blue-tinted -->
                  <button type="button"
                          class="font-semi uppercase tracking-wide"
                          style="background: none; border: 0; padding: 0; color: inherit;"
                          data-cy="sku-inactive-toggle"
                          :aria-expanded="showInactive ? 'true' : 'false'"
                          @click="showInactive = !showInactive">
                    <i class="fa-fw" :class="showInactive ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-right'"></i>
                    Inactive ({{ inactiveCount }})
                  </button>
                </div>
                <div v-if="plan.active || showInactive"
                     :key="plan.id || `new-${index}`"
                     data-cy="sku-row"
                     class="grid sm-grid-cols-1 gap-x-sm"
                     :class="[planGridClass(index), { 'rounded-sm p-x-xs p-t-xs': !plan.active }]">
                  <div class="form-group">
                    <label class="font-normal sr-only">Name</label>
                    <input v-model="plan.name" type="text" class="form-control">
                  </div>
                  <div v-if="isPrivateLesson" class="form-group">
                    <label class="font-normal sr-only"># of Wrestlers in Lesson</label>
                    <input v-model="plan.max_wrestler_count" type="number" class="form-control">
                  </div>
                  <div class="form-group">
                    <label class="font-normal  sr-only">Amount</label>
                    <money v-model="plan.amount" v-bind="money" class="form-control"></money>
                  </div>
                  <div class="form-group" v-if="isPrivateLesson">
                    <label class="font-normal sr-only">Facility fee</label>
                    <span class="flex gap-x-xs align-items-center">
                      <select v-model="plan.facility_fee_type" class="form-control" style="max-width: 84px;">
                        <option value="hourly">$/hr</option>
                        <option value="percent">%</option>
                      </select>
                      <money v-if="plan.facility_fee_type !== 'percent'" v-model="plan.facility_price_per_hour" v-bind="money" class="form-control"></money>
                      <input v-else v-model.number="plan.facility_percent_fee" type="number" min="1" max="99" step="1" placeholder="%" class="form-control">
                    </span>
                  </div>
                  <div class="form-group" v-if="isClothing">
                    <label class="font-normal sr-only">Fit</label>
                    <input v-model="plan.fit" type="text" class="form-control" placeholder="Men's" data-cy="sku-fit">
                  </div>
                  <div class="form-group" v-if="isClothing">
                    <label class="font-normal sr-only">Color</label>
                    <input v-model="plan.color" type="text" class="form-control" data-cy="sku-color">
                  </div>
                  <div class="form-group" v-if="isClothing">
                    <label class="font-normal sr-only">Size</label>
                    <input v-model="plan.size" type="text" class="form-control" data-cy="sku-size">
                  </div>
                  <div class="form-group" v-if="!isPrivateLesson">
                    <label class="font-normal sr-only">Sku ID</label>
                    <input v-model="plan.vendor_sku_id" type="text" class="form-control" data-cy="sku-vendor-id">
                  </div>
                  <div class="form-group" v-if="showAttendeeCountColumn">
                    <label class="font-normal sr-only">Attendees per sku</label>
                    <input v-model.number="plan.attendee_count" type="number" min="1" step="1" class="form-control">
                  </div>
                  <div class="form-group flex align-items-center gap-x-xs">
                    <button type="button"
                            class="btn btn-default btn-outline font-small"
                            style="padding: 2px 8px"
                            data-cy="sku-toggle-active"
                            @click.prevent="setActive(plan, !plan.active)">
                      {{ plan.active ? 'Deactivate' : 'Activate' }}
                    </button>
                  </div>
                </div>
                </template>
                <div class="grid grid-cols-3 md-grid-cols-1 gap-x-sm align-items-center">
                  <div class="bg bg-gray-50 border-gray-200 rounded-sm p-sm m-b-sm flex-shrink-1" v-if="isClothing">
                    <h2 class="m-b-none"><i class="fa-solid fa-wand-magic-sparkles"></i> Size/Color/Fit Shortcuts</h2>
                    <p>
                      Enter a comma separated list of sizes, and optionally colors and fits (like Men's, Women's, Youth), to quickly add every combination as unique skus.
                    </p>
                    <div class="form-group">
                      <label for="size-shortcut">Sizes</label>
                      <input id="size-shortcut" type="text" v-model="sizeShortcut" class="form-control"/>
                    </div>
                    <div class="form-group">
                      <label for="color-shortcut">Colors</label>
                      <input id="color-shortcut" type="text" v-model="colorShortcut" class="form-control"/>
                    </div>
                    <div class="form-group">
                      <label for="fit-shortcut">Fits</label>
                      <input id="fit-shortcut" type="text" v-model="fitShortcut" class="form-control" placeholder="Men's, Women's, Youth"/>
                    </div>
                    <div class="form-group">
                      <label for="sizes">Price</label>
                      <money v-model="priceShortcut" v-bind="money" class="form-control"></money>
                    </div>
                    <button class="btn btn-default" data-cy="generate-skus" @click.prevent="generateSizes">
                      <i class="fa-solid fa-square-plus"></i> Generate Skus
                    </button>
                  </div>
                  <div v-if="isClothing" class="text-center flex justify-center">
                    <h3>Or</h3>
                  </div>
                  <div class="flex" :class="isClothing ? 'justify-center': ''">
                    <a class="btn btn-default" data-cy="add-sku" @click.prevent="addBillingPlan('', '', 0, isPrivateLesson ? '' : name)">
                      <i class="fa-solid fa-plus"></i> Add <span v-if="isClothing">Single</span> <span v-if="isPrivateLesson">Private Lesson Price</span><span v-else>Sku</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Bundles: slots instead of skus (.ai/features/20261001_store_bundles.md) -->
          <div class="row m-t-xl" v-if="isBundle">
            <div class="col-md-4">
              <h1 class="form-section-title">Bundle items</h1>
              <p>Add one item for each thing in the bundle, like a singlet, shorts and a hoodie. Families pick a size for each.</p>
              <p class="text-gray-500">The bundle price is the total of what families pick, less any bundle discount. Photos come from the products inside the bundle.</p>
            </div>
            <div class="col-md-8">
              <div
                v-for="(slot, index) in visibleBundleSlots"
                :key="slot.key"
                class="border border-solid border-gray-200 rounded-sm p-m m-b-sm"
              >
                <div class="flex align-items-center gap-sm">
                  <select
                    v-model="slot.option_product_id"
                    class="form-control"
                    :name="`bundle_slot_product_${index}`"
                    :aria-label="`Item ${index + 1} product`"
                  >
                    <option :value="null" disabled>Choose a product…</option>
                    <option v-for="product in bundleProducts" :key="product.id" :value="product.id">{{ bundleProductLabel(product.id) }}</option>
                  </select>
                  <label class="flex align-items-center gap-x-xxs font-normal m-b-none flex-shrink-0" :for="`bundle_slot_quantity_${index}`">
                    Qty
                    <input
                      :id="`bundle_slot_quantity_${index}`"
                      v-model.number="slot.quantity"
                      type="number"
                      min="1"
                      max="10"
                      class="form-control bundle-slot-quantity"
                      :name="`bundle_slot_quantity_${index}`"
                    >
                  </label>
                  <div class="btn-group btn-group-sm flex-shrink-0">
                    <button type="button" class="btn btn-default" :disabled="index === 0" aria-label="Move up" @click="moveSlot(slot, -1)"><i class="fa-solid fa-arrow-up"></i></button>
                    <button type="button" class="btn btn-default" :disabled="index === visibleBundleSlots.length - 1" aria-label="Move down" @click="moveSlot(slot, 1)"><i class="fa-solid fa-arrow-down"></i></button>
                    <button type="button" class="btn btn-default" aria-label="Remove item" @click="removeSlot(slot)"><i class="fa-solid fa-trash"></i></button>
                  </div>
                </div>
              </div>
              <p v-if="bundleProductsLoading" class="text-gray-500">Loading products…</p>
              <p v-else-if="bundleProductsLoadError" class="text-gray-500">
                We couldn't load your products.
                <button type="button" class="btn btn-link btn-compact" @click="loadBundleProducts">Try again</button>
              </p>
              <p v-else-if="bundleProducts.length === 0" class="text-gray-500">
                Create the individual products first (like a singlet with its sizes), then bundle them here.
              </p>
              <button type="button" class="btn btn-default" @click="addSlot"><i class="fa-solid fa-plus"></i> Add item</button>

              <div class="form-group m-t-lg">
                <label for="bundle_discount_percent">Bundle discount</label>
                <div class="input-group bundle-discount-input">
                  <input
                    id="bundle_discount_percent"
                    v-model.number="bundleDiscountPercent"
                    type="number"
                    min="0"
                    max="50"
                    step="1"
                    class="form-control"
                    name="bundle_discount_percent"
                    placeholder="0"
                  >
                  <span class="input-group-addon">% off</span>
                </div>
                <p class="help-block">Taken off each item families pick in this bundle, so buying the set costs less than buying the items one at a time. Add-ons stay full price.</p>
              </div>
            </div>
          </div>
          <div class="row m-t-xl" v-show="this.category && !isPrivateLesson && !isBundle">
            <div class="col-md-4">
              <h1 class="form-section-title">Add-ons</h1>
              <p>Not finding anything? Create <a href="/upsells" target="_blank">add-ons first here.</a></p>
            </div>
            <div class="col-md-8">
              <search
                  class="search-form"
                  response-key="upsells"
                  placeholder="Type name of the add-on..."
                  :mutate-history="false"
                  :allow-add="false"
                  :small-input="true"
                  :display-all-on-empty="false"
                  readable-model-name="upsell"
                  base-url="/api/v1/upsells"
              >
                <template v-slot:list="slotProps">
                  <div
                      class="border-top m-t-sm m-b-xs p-t-sm p-b-xs cursor-pointer flex justify-space-between align-items-center p-r-sm"
                      @click="upsellClicked(slotProps.result)"
                  >
                    <div>
                      {{ slotProps.result.name }}
                    </div>
                    <div
                        class="border rounded-sm border-blue-200 border-solid font-small"
                        style="padding: 2px 6px"
                    >
                      Add
                    </div>
                  </div>
                </template>
              </search>
              <div class="flex flex-col gap-y-xs m-t-sm">
                <div
                    v-for="upsell in notDestroyedUpsells"
                    :key="upsell.id"
                    class="flex align-items-center gap-x-sm border border-solid rounded-lg p-x-sm p-y-xs"
                    style="border-color: #d1d5db"
                >
                  <div class="flex-1 font-small">
                    {{ upsell.name }}
                  </div>
                  <label class="flex align-items-center gap-x-xxs m-b-none font-small cursor-pointer" :for="`upsell-required-${upsell.id}`">
                    <input
                        :id="`upsell-required-${upsell.id}`"
                        type="checkbox"
                        :checked="isUpsellRequired(upsell)"
                        :disabled="!upsell.active"
                        @change="toggleUpsellRequired(upsell)"
                    >
                    Required
                  </label>
                  <button
                      @click.prevent="upsellClicked(upsell)"
                      class="btn btn-default btn-outline rounded-lg font-small"
                      style="padding: 2px 6px"
                      title="Remove"
                  >
                    <i class="fa-solid fa-xmark"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="row m-t-xl" v-show="this.category && !isPrivateLesson && !isBundle">
            <div class="col-md-4">
              <h1 class="form-section-title">Images</h1>
            </div>
            <div class="col-md-8 filepond--grid-layout">
              <pintura-photo-uploader
                  :access-key="accessKey"
                  :endpoint="endpoint"
                  :cloudfront-base-url="cloudfrontBaseUrl + '/'"
                  :existing-attachments="existingPhotosUniqByS3Key"
                  :max-files="10"
                  prefix="billing_plans/"
                  imageCropAspectRatio="1"
                  @photos-changed="photosChanged"
              ></pintura-photo-uploader>
            </div>
          </div>
          <div class="button-area text-right m-t-xl">
            <div>
              <ladda-button @lbClicked="saveProduct" el-class="btn-primary" :loading="loading">
                Save
              </ladda-button>
              <div v-if="error">
                <small>
                  <span class="text-danger">{{ errorMessage }}</span>
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Money } from 'v-money';
import Spinner from './spinner.vue';
import LaddaButton from '../../shared/ladda_button.vue';
import { errorableMix } from './mixins/errorable_mix';
import { trixFileAttachmentMix } from './mixins/trix_file_attachment_mix';
import { photoUploadMix } from './mixins/photo_upload_mix.js';
import PinturaPhotoUploader from './pintura_photo_uploader.vue';
import Search from '../../shared/search.vue';

export default {
  name: 'product-form',
  mixins: [errorableMix, trixFileAttachmentMix, photoUploadMix],
  components: {
    PinturaPhotoUploader,
    Money,
    LaddaButton,
    Spinner,
    Search,
  },
  props: {
    existingProduct: {
      type: Object,
      required: false,
    },
    preSelectedCategory: {
      type: String,
      default: '',
    },
    currency: {
      type: String,
      default: 'usd',
    },
  },
  data() {
    return {
      name: '',
      description: '',
      descriptionTrixEditor: null,
      category: '',
      collectAttendeeInfo: false,
      fabricCare: '',
      fabricCareTrixEditor: null,
      //  size and color shortcu are for clothing only and a comma separated list of sizes and colors
      sizeShortcut: '',
      colorShortcut: '',
      fitShortcut: '',
      priceShortcut: '',
      billingPlanAddOns: [],
      // A key by id array of upsells to make billingPlanAddOns make sense in the UI
      upsells: {},

      loading: false,
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        suffix: '',
        precision: 2,
        masked: false,
      },

      billingPlans: [],
      // Inactive skus are collapsed under their header until the admin expands them
      showInactive: false,
      redirectUrl: '/products',

      // Bundle category: [{ id?, key, name, quantity, option_product_id, _destroy }]
      bundleSlots: [],
      // Percent off each piece bought in the bundle (blank = no discount)
      bundleDiscountPercent: '',
      // The team's goods that can go in a bundle (not bundles, no attendee collection)
      bundleProducts: [],
      bundleProductsLoading: false,
      // A failed load shows a retry instead of the "create products first" empty state
      bundleProductsLoadError: false,
      nextBundleSlotKey: 1,
    };
  },
  watch: {
    category(newValue) {
      if (this.existingProduct) {
        return;
      }

      // Ticket products almost always want attendee names, so default the toggle on for new products
      this.collectAttendeeInfo = newValue === 'ticket';

      if (newValue === 'bundle') {
        this.billingPlans = [];
        this.loadBundleProducts();
        if (this.bundleSlots.length === 0) this.addSlot();
        return;
      }

      if (this.category === 'clothing') {
        this.billingPlans = [];
      } else if (this.billingPlans.length === 0) {
        this.$nextTick(() => {
          // shortcut to add one plan to it, if needed
          this.addBillingPlan('', '', 0, '');
        });
      }
    },
  },
  mounted() {
    if (this.existingProduct) {
      this.name = this.existingProduct.name;
      this.description = this.existingProduct.description;
      this.category = this.existingProduct.category;
      this.collectAttendeeInfo = this.existingProduct.collect_attendee_info || false;
      this.fabricCare = this.existingProduct.fabric_and_care;
      this.billingPlans = _.map(this.existingProduct.billing_plans, (plan) => {
        plan._destroy = false;
        plan.amount /= 100;
        if (plan.facility_price_per_hour) {
          plan.facility_price_per_hour /= 100;
        }
        // API stores a fraction (0.30); the form works in whole percents (30)
        plan.facility_fee_type = plan.facility_fee_type || 'hourly';
        plan.facility_percent_fee = plan.facility_percent_fee ? _.round(plan.facility_percent_fee * 100) : null;
        return plan;
      });
      // Is this going to work? Needs lots of testing, I'm missing something here
      this.billingPlanAddOns = _.flatMap(this.existingProduct.billing_plans, (plan) => {
        // Build up our key by id array of upsells
        plan.upsells.forEach((upsell) => {
          this.$set(this.upsells, upsell.id, upsell);
          this.$set(this.upsells[upsell.id], '_destroy', false);
        });

        return _.map(plan.billing_plan_add_ons, (addOn) => {
          addOn._destroy = false;
          return addOn;
        });
      });

      if (this.existingProduct.category === 'bundle') {
        this.bundleSlots = _.map(this.existingProduct.bundle_slots, (slot) => ({
          ...slot, key: `slot-${slot.id}`, _destroy: false,
        }));
        this.bundleDiscountPercent = this.existingProduct.bundle_discount_percent || '';
        this.loadBundleProducts();
      }

      // Trix might already be initialized so explicitly try to load it
      this.loadTrixContent(this.descriptionTrixEditor, this.description);
      this.loadTrixContent(this.fabricCareTrixEditor, this.fabricCare);
    } else if (this.preSelectedCategory === 'private_lesson') {
      // If we have a pre-selected category, set it
      this.category = this.preSelectedCategory;
    }

    // otherwise listen for that init event
    document.addEventListener('trix-initialize', this.trixInit);
  },
  destroyed() {
    document.removeEventListener('trix-initialize', this.trixInit);
  },
  computed: {
    notDestroyedUpsells() {
      return _.filter(Object.values(this.upsells), (upsell) => !upsell._destroy);
    },
    // Method that checks whether the current category is clothing
    isClothing() {
      return this.category === 'clothing';
    },
    isPrivateLesson() {
      return this.category === 'private_lesson';
    },
    // Where the Inactive header row goes (-1 = no inactive skus). Relies on billingPlans staying active-first.
    firstInactiveIndex() {
      return this.billingPlans.findIndex((plan) => !plan.active);
    },
    inactiveCount() {
      return this.billingPlans.filter((plan) => !plan.active).length;
    },
    isBundle() {
      return this.category === 'bundle';
    },
    visibleBundleSlots() {
      return _.reject(this.bundleSlots, '_destroy');
    },
    showAttendeeCountColumn() {
      return this.collectAttendeeInfo && !this.isPrivateLesson;
    },
    existingPhotosUniqByS3Key() {
      return _.uniqBy(this.existingAttachments, 'key');
    },
    addOnParams() {
      // Remove all the front end stuff we use to manage the addons
      return _.flatMap(this.billingPlanAddOns, (addOn) => ({
        id: addOn.id,
        _destroy: addOn._destroy,
        upsell_id: addOn.upsell_id,
        required: addOn.required || false,
      }));
    },
  },
  methods: {
    attendeeCountParam(plan) {
      // Blank/absent falls back to 1 (the column may be hidden); invalid visible input is caught in validate()
      const count = (plan.attendee_count === '' || plan.attendee_count == null) ? 1 : plan.attendee_count;
      // When the column is hidden a stale invalid value can't be corrected by the user, so normalize it
      if (!this.showAttendeeCountColumn && (!Number.isInteger(count) || count < 1)) {
        return 1;
      }
      return count;
    },
    getGridColsClass() {
      const attendeeCol = this.showAttendeeCountColumn ? 1 : 0;
      if (this.isClothing) {
        return `grid-cols-${7 + attendeeCol}`;
      } if (this.isPrivateLesson) {
        return 'grid-cols-5';
      }
      return `grid-cols-${4 + attendeeCol}`;
    },
    billingPlansParams() {
      return this.billingPlans.map((plan) => {
        const params = {
          id: plan.id,
          updated_at: new Date().toISOString(),
          name: plan.name,
          _destroy: plan._destroy,
          amount: _.round(plan.amount * 100),
          currency: plan.currency,
          usage_type: 'licensed',
          interval: 'one_time',
          inventory_type: 'infinite',
          vendor_sku_id: plan.vendor_sku_id,
          attendee_count: this.attendeeCountParam(plan),
          sold_out: plan.sold_out,
          active: plan.active,
          fit: plan.fit,
          color: plan.color,
          size: plan.size,
          max_wrestler_count: plan.max_wrestler_count,
          facility_price_per_hour: plan.facility_price_per_hour ? _.round(plan.facility_price_per_hour * 100) : null,
          facility_fee_type: plan.facility_fee_type || 'hourly',
          facility_percent_fee: plan.facility_percent_fee ? _.round(plan.facility_percent_fee) / 100 : null,
          // photo attributes are weird, because we push them into the billing plans, we do not use the attachment id we create a new record
          photos_attributes: this.attachmentParamsForBillingPlan(plan),
          billing_plan_add_ons_attributes: this.upsellParamsForBillingPlan(plan),
        };

        return params;
      });
    },
    attachmentAlreadyAttachedToOtherPlan(attachment) {
      // loop through all billing plan photos, return whether this attachment.id is present in any of them
      return _.some(this.billingPlans, (plan) => _.some(plan.photos, (photo) => photo.id === attachment.id));
    },
    attachmentParamsForBillingPlan(plan) {
      return _.compact(_.flatMap(this.attachmentParams, (attachment) => {
        // Loop through the photos on the plan, if we find the attachment id, we update the _destroy flag as needed
        for (let i = 0; i < plan.photos.length; i++) {
          if (plan.photos[i].id === attachment.id) {
            return {
              id: attachment.id,
              _destroy: attachment._destroy,
            };
          }
        }

        // If we didn't find the attachment on any other object, we add it to the array because this is a new attachment
        // todo test with adding a new photo, but not finalizing, etc
        if (!this.attachmentAlreadyAttachedToOtherPlan(attachment)) {
          return {
            id: attachment.id,
            _destroy: attachment._destroy,
          };
        }

        return null;
      }));
    },
    upsellParamsForBillingPlan(plan) {
      const attrs = [];
      const seenUpsellIds = [];
      const planRows = plan.billing_plan_add_ons || [];

      // Rows this plan already has: update or destroy them in place
      this.addOnParams.forEach((addOn) => {
        if (!addOn.id || !_.some(planRows, { id: addOn.id })) {
          return;
        }
        seenUpsellIds.push(addOn.upsell_id);
        attrs.push({
          id: addOn.id,
          _destroy: addOn._destroy,
          upsell_id: addOn.upsell_id,
          required: addOn.required,
        });
      });

      // Any live add-on the plan lacks gets a fresh row — covers brand-new add-ons
      // and variants added after the add-on was configured, which historically never
      // received rows (so the storefront/funnel silently skipped their user input)
      this.addOnParams.forEach((addOn) => {
        if (addOn._destroy || _.includes(seenUpsellIds, addOn.upsell_id)) {
          return;
        }
        seenUpsellIds.push(addOn.upsell_id);
        attrs.push({
          upsell_id: addOn.upsell_id,
          required: addOn.required,
        });
      });

      return attrs;
    },
    upsellClicked(upsell) {
      this.$notificationManager.emit('profile-clicked');
      // This method loop sthrough billing plan addons, looking for billing plan add ons with upsell.id == to billing_plan_add_on.upsell_id
      // if found, it updates the _destroy flag on it, if not found, it adds a new billing plan add on with the upsell id
      const existingAddOns = _.filter(this.billingPlanAddOns, (addOn) => addOn.upsell_id === upsell.id);
      const found = existingAddOns.length > 0;
      let isDestroyed = false;
      if (found) {
        // write for loop of this same map code
        const draftIndexesToRemove = [];
        for (let i = 0; i < this.billingPlanAddOns.length; i++) {
          if (this.billingPlanAddOns[i].upsell_id === upsell.id) {
            this.billingPlanAddOns[i]._destroy = !this.billingPlanAddOns[i]._destroy;
            if (this.billingPlanAddOns[i]._destroy) {
              isDestroyed = true;
            }

            if (this.billingPlanAddOns[i]._destroy && !this.billingPlanAddOns[i].id) {
              draftIndexesToRemove.push(i);
            }
          }
        }
        this.billingPlanAddOns = this.billingPlanAddOns.filter((addOn, index) => !draftIndexesToRemove.includes(index));
      } else {
        // If this upsell is not found in the billing plan add ons, create it
        this.billingPlanAddOns.push({
          id: null,
          upsell_id: upsell.id,
          _destroy: false,
          required: false,
        });
      }
      this.$set(this.upsells, upsell.id, upsell);
      this.$set(this.upsells[upsell.id], '_destroy', isDestroyed);
    },
    isUpsellRequired(upsell) {
      const addOn = _.find(this.billingPlanAddOns, (a) => a.upsell_id === upsell.id && !a._destroy);
      return !!(addOn && addOn.required);
    },
    toggleUpsellRequired(upsell) {
      if (!upsell.active) {
        return;
      }
      const next = !this.isUpsellRequired(upsell);
      this.billingPlanAddOns.forEach((addOn) => {
        if (addOn.upsell_id === upsell.id && !addOn._destroy) {
          this.$set(addOn, 'required', next);
        }
      });
    },
    // Index of the first inactive sku, i.e. where the active group ends. New and re-sorted skus go here.
    activeGroupEnd() {
      const index = this.billingPlans.findIndex((plan) => !plan.active);
      return index === -1 ? this.billingPlans.length : index;
    },
    setActive(plan, active) {
      // Move the sku to the edge of its new group so billingPlans stays active-first
      this.billingPlans.splice(this.billingPlans.indexOf(plan), 1);
      plan.active = active;
      this.billingPlans.splice(this.activeGroupEnd(), 0, plan);
      // Expand the section so a just-deactivated sku doesn't look like it disappeared
      if (!active) {
        this.showInactive = true;
      }
    },
    planGridClass(index) {
      let classes = '';
      if (index > 0) {
        classes += ' m-t-xs';
      }
      classes += ` ${this.getGridColsClass()}`;

      return classes;
    },
    generateSizes() {
      const sizes = this.sizeShortcut.split(',');
      const colors = this.colorShortcut.split(',');
      const fits = this.fitShortcut.split(',');
      fits.forEach((fit) => {
        sizes.forEach((size) => {
          colors.forEach((color) => {
            this.addBillingPlan(color.trim(), size.trim(), this.priceShortcut, this.name, fit.trim());
          });
        });
      });

      this.sizeShortcut = '';
      this.colorShortcut = '';
      this.fitShortcut = '';
      this.priceShortcut = '';
    },
    addBillingPlan(color, size, amount, name, fit = '') {
      // New skus are active, so they go at the end of the active group, above any inactive ones
      this.billingPlans.splice(this.activeGroupEnd(), 0, {
        name,
        _destroy: false,
        amount,
        currency: this.currency || 'usd',
        usage_type: 'licensed',
        interval: 'one_time',
        inventory_type: 'infinite',
        max_wrestler_count: null,
        facility_price_per_hour: 0,
        facility_fee_type: 'hourly',
        facility_percent_fee: null,
        vendor_sku_id: '',
        attendee_count: 1,
        sold_out: false,
        active: true,
        fit,
        color,
        size,
        photos: [],
        billing_plan_add_ons: [],
      });
    },
    trixInit(e) {
      if (e.target.id === 'trix-description') {
        this.descriptionTrixEditor = e.target.editor;
        this.loadTrixContent(this.descriptionTrixEditor, this.description);
      } else if (e.target.id === 'trix-fabric') {
        this.fabricCareTrixEditor = e.target.editor;
        this.loadTrixContent(this.fabricCareTrixEditor, this.fabricCare);
      }
    },
    loadTrixContent(trixEditor, html) {
      if (trixEditor) {
        trixEditor.loadHTML(html);
      }
    },
    // Inactive skus are collapsed by default, so expand them when one of them is what failed validation
    revealInactiveIfNeeded(invalidPlans) {
      if (invalidPlans.some((plan) => !plan.active)) {
        this.showInactive = true;
      }
    },
    validate() {
      if (!this.name) {
        this.error = true;
        this.errorMessage = 'Name is required';
        return false;
      }
      if (!this.category) {
        this.error = true;
        this.errorMessage = 'Category is required';
        return false;
      }
      const description = $('#description-editor').val();
      if (!description) {
        this.error = true;
        this.errorMessage = 'Description is required';
        return false;
      }
      if (this.isBundle) {
        return this.validateBundle();
      }
      if (this.billingPlans.length === 0) {
        this.error = true;
        this.errorMessage = 'At least one sku is required';
        return false;
      }
      if (this.isClothing) {
        // Color and fit are optional (a one-color team piece has none); size is what the shopper picks
        const missingSize = this.billingPlans.filter((plan) => !plan.size);
        if (missingSize.length > 0) {
          this.revealInactiveIfNeeded(missingSize);
          this.error = true;
          this.errorMessage = 'Size is required for clothing.';
          return false;
        }
      }
      if (this.showAttendeeCountColumn) {
        const badAttendeeCount = this.billingPlans.filter((plan) => !plan._destroy
          && (!Number.isInteger(plan.attendee_count) || plan.attendee_count < 1));
        if (badAttendeeCount.length > 0) {
          this.revealInactiveIfNeeded(badAttendeeCount);
          this.error = true;
          this.errorMessage = 'Attendees per sku must be a whole number of 1 or more.';
          return false;
        }
      }
      if (this.isPrivateLesson) {
        this.billingPlans.forEach((plan) => {
          if (!plan.max_wrestler_count) {
            this.error = true;
            this.errorMessage = 'Max wrestler count is required for private lessons.';
          }
          if (plan.facility_fee_type === 'percent') {
            if (!plan.facility_percent_fee || plan.facility_percent_fee < 1 || plan.facility_percent_fee > 99) {
              this.error = true;
              this.errorMessage = 'Facility fee percent must be between 1 and 99 for private lessons.';
            }
          } else if (plan.facility_price_per_hour === null || plan.facility_price_per_hour === undefined || plan.facility_price_per_hour === '') {
            this.error = true;
            this.errorMessage = 'Facility price per hour is required for private lessons. Set to 0 if you do not need it.';
          }
        });
      }
      return true;
    },
    params() {
      return {
        product: {
          name: this.name,
          product_type: this.isPrivateLesson ? 'service' : 'good', // All e-commerce related products are goods, all private lessons are services
          category: this.category,
          collect_attendee_info: this.isPrivateLesson || this.isBundle ? false : this.collectAttendeeInfo,
          description: $('#description-editor').val(),
          fabric_and_care: $('#fabric-editor').val(),
          billing_plans_attributes: this.billingPlansParams(),
          ...(this.isBundle ? {
            bundle_slots_attributes: this.bundleSlotsParams(),
            bundle_discount_percent: this.bundleDiscountPercent === '' ? null : this.bundleDiscountPercent,
          } : {}),
        },
      };
    },
    validateBundle() {
      if (this.visibleBundleSlots.length === 0) {
        this.error = true;
        this.errorMessage = 'Add at least one item to the bundle.';
        return false;
      }
      const incomplete = this.visibleBundleSlots.find((slot) => !slot.option_product_id);
      if (incomplete) {
        this.error = true;
        this.errorMessage = 'Every bundle item needs a product.';
        return false;
      }
      return true;
    },
    bundleSlotsParams() {
      const kept = this.visibleBundleSlots.map((slot, index) => ({
        id: slot.id,
        // Each item is one product and takes its name
        name: this.bundleProductName(slot.option_product_id) || slot.name,
        quantity: slot.quantity || 1,
        position: index,
        option_product_id: slot.option_product_id,
      }));
      const removed = this.bundleSlots.filter((slot) => slot._destroy && slot.id).map((slot) => ({ id: slot.id, _destroy: true }));
      return [...kept, ...removed];
    },
    loadBundleProducts() {
      if (this.bundleProductsLoading || this.bundleProducts.length > 0) return;
      this.bundleProductsLoadError = false;
      this.bundleProductsLoading = true;
      axios.get(this.$apiService.productsUrl(), { params: { per_page: 500, q: { product_type_eq: 'good' } } })
        .then((response) => {
          const ownId = this.existingProduct && this.existingProduct.id;
          this.bundleProducts = _.sortBy(response.data.products.filter((product) => product.category !== 'bundle'
            && !product.collect_attendee_info && product.id !== ownId), 'name');
          this.bundleProductsLoading = false;
        })
        .catch(() => {
          this.bundleProductsLoading = false;
          this.bundleProductsLoadError = true;
        });
    },
    addSlot() {
      this.bundleSlots.push({
        key: `new-${this.nextBundleSlotKey}`, name: '', quantity: 1, option_product_id: null, _destroy: false,
      });
      this.nextBundleSlotKey += 1;
    },
    removeSlot(slot) {
      if (slot.id) {
        slot._destroy = true;
      } else {
        this.bundleSlots.splice(this.bundleSlots.indexOf(slot), 1);
      }
    },
    moveSlot(slot, direction) {
      const visible = this.visibleBundleSlots;
      const target = visible[visible.indexOf(slot) + direction];
      if (!target) return;
      const from = this.bundleSlots.indexOf(slot);
      const to = this.bundleSlots.indexOf(target);
      this.bundleSlots.splice(from, 1, target);
      this.bundleSlots.splice(to, 1, slot);
    },
    bundleProductName(productId) {
      return _.get(this.bundleProducts.find((p) => p.id === productId), 'name');
    },
    // Name plus colors and price, so same-named products (e.g. two "T-shirt"s) are distinguishable
    bundleProductLabel(productId) {
      const product = this.bundleProducts.find((p) => p.id === productId);
      if (!product) return `Product #${productId}`;
      const plans = _.filter(product.billing_plans, 'active');
      const colors = _.uniq(_.compact(_.map(plans, 'color')));
      const amounts = _.map(plans, 'amount');
      const details = [];
      if (colors.length) details.push(colors.join('/'));
      if (amounts.length) {
        const [min, max] = [_.min(amounts) / 100, _.max(amounts) / 100];
        details.push(min === max ? `$${min}` : `$${min}–$${max}`);
      }
      return details.length ? `${product.name} (${details.join(' · ')})` : product.name;
    },
    saveProduct: _.throttle(function () {
      if (this.loading) {
        return;
      }

      const valid = this.validate();
      if (valid) {
        this.error = false;
        this.errorMessage = '';

        if (this.existingProduct) {
          this.updateExistingProduct();
        } else {
          this.createProduct(this.params());
        }
      }
    }, 500),
    createProduct(params) {
      this.loading = true;
      const url = this.$apiService.productsUrl();
      axios.post(url, params)
        .then((response) => {
          this.loading = false;
          this.$notificationManager.emit('show-toast', 'Saved', true);
          window.location.assign(this.redirectUrl || '/products');
        })
        .catch((error) => {
          this.loading = false;
          this.showError(this.parseErrorResponse(error));
        });
    },
    async updateExistingProduct() {
      this.loading = true;
      const url = this.$apiService.productUrl(this.existingProduct.id);
      try {
        await axios.put(url, this.params());
        this.loading = false;
        this.$notificationManager.emit('show-toast', 'Saved', true);
        window.location.assign(this.redirectUrl || '/products');
      } catch (error) {
        this.loading = false;
        this.showError(this.parseErrorResponse(error));
      }
    },
  },
};
</script>
<style scoped>
</style>
